import { cn, formatCurrency } from '@/shared/lib'

import { TRoomDetail } from '../model/schema'

export type Props = Pick<
  TRoomDetail,
  | 'roomName'
  | 'roomCnt'
  | 'bathroomCnt'
  | 'sittingroomCnt'
  | 'cookroomCnt'
  | 'usingFee'
  | 'mgmtFee'
> & {
  propertyType: string
  province: string
  town: string
  size: 'small' | 'large'
}

export const Overview = ({
  size,
  province,
  town,
  propertyType,
  roomName,
  roomCnt,
  bathroomCnt,
  sittingroomCnt,
  cookroomCnt,
  usingFee,
  mgmtFee,
}: Props) => {
  return (
    <>
      <div className="mb-[6px] space-y-1">
        <h3
          className={cn('font-semibold text-gray-900', {
            'typo-body2': size === 'small',
            'typo-body1': size === 'large',
          })}
        >{`${province} ${town}의 ${propertyType}`}</h3>
        <p className="typo-label1 font-normal text-gray-900">{roomName}</p>
        <div className="typo-label1 flex gap-2 font-normal text-gray-500">
          {roomCnt > 0 && (
            <p className="space-x-px">
              <span>방</span>
              <span className="text-gray-900">{roomCnt}</span>
            </p>
          )}
          {bathroomCnt > 0 && (
            <p className="space-x-px">
              <span>화장실</span>
              <span className="text-gray-900">{bathroomCnt}</span>
            </p>
          )}
          {cookroomCnt > 0 && (
            <p className="space-x-px">
              <span>주방</span>
              <span className="text-gray-900">{cookroomCnt}</span>
            </p>
          )}
          {sittingroomCnt > 0 && (
            <p className="space-x-px">
              <span>거실</span>
              <span className="text-gray-900">{sittingroomCnt}</span>
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-1 [&:not(:last-child)]:mb-[4px]">
        <p className="flex items-center gap-0.5 font-bold text-gray-900">
          <strong className="typo-headline3 font-bold">
            {formatCurrency(usingFee + mgmtFee)}
          </strong>
          <span className="typo-label1">원</span>
        </p>
        <span className="typo-body1-reading font-light text-gray-200">/</span>
        <span className="typo-body1 font-bold text-purple-500">1주</span>
      </div>
    </>
  )
}
